/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
import { compoundVersionIdSchemaZ } from './components';
export const paFlows = ['ESS only Project', 'PV only Project', 'PV+ESS Project'];
export const paBatchFlows = ['ESS Only Batch', 'PV Only Batch', 'PV+ESS Batch'];
export const plantSimFlows = [
    'PlantSim',
    'PlantSim Batch',
    'PlantSim Net Benefit',
    'PlantSim v2 Batch',
    'PlantSim v2',
    'PlantSim v2 Net Benefit',
];
export const pvSimComponentFlows = ['PVSim weather from API', 'Solar Resource Report'];
export const pvsimFlows = ['PVSim simulate energy'];
export const pvCostingFlows = ['PVCosting only'];
export const essCostingFlows = ['ESS Costing only, Li-ion'];
export const pricesFlows = ['Add Price Curves'];
export const gisFlows = ['Energy Scoring'];
export const metsimFlows = [
    'METSAT Fleet Report',
    'METCAP',
    'METSAT',
    'METSOIL',
    'METSAT PVSim Comparison',
];
export const brFlows = [
    'Update BRWF Eng Results',
    'BRWF Agent Vetting',
    'Economic Optimum Gathering',
];
export const uploadPricingScenariosFlow = 'Upload Pricing Scenarios';
const financierFlows = [uploadPricingScenariosFlow];
export const allProjectFlows = [...paFlows, ...paBatchFlows, ...gisFlows];
export const coreServices = ['pv_sim', 'pv_costing', 'ess_costing', 'plant_sim'];
export const coreServiceToFlow = {
    pv_sim: 'PVSim simulate energy',
    pv_costing: 'PVCosting only',
    ess_costing: 'ESS Costing only, Li-ion',
    plant_sim: 'PlantSim',
};
export const defaultBatchData = {
    start: '',
    end: '',
    step: '',
};
export const parseBatchableNumber = (batch) => {
    if (batch === null || batch === undefined)
        return defaultBatchData;
    if (typeof batch === 'number') {
        return { ...defaultBatchData, start: batch.toString() };
    }
    return { start: batch[0].toString(), end: batch[1].toString(), step: batch[2].toString() };
};
export const poweralphaRequestSchema = z.object({
    project_id: z.string(),
    project_name: z.string(),
    project_object: z.enum(['Project__c', 'M_A_Project__c']).default('Project__c'),
    pv_config_id: compoundVersionIdSchemaZ.optional(),
    ess_config_id: compoundVersionIdSchemaZ.optional(),
    fimo_config_id: compoundVersionIdSchemaZ.optional(),
});
export const multiConfigPaRequestSchema = z.object({
    configs: z.array(poweralphaRequestSchema),
});
export const componentIdSchema = z.object({ id: z.uuid() });
export const paginationSchema = z.object({
    limit: z.int().min(0).default(100),
    offset: z.int().min(0).default(0),
});
//# sourceMappingURL=core.js.map